import { FC } from 'react';

import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';
import PlanTableRow from './PlanTableRow';

const PlanTableBody: FC = () => {
  const { data } = useBeneficiarySellModal();

  return (
    <tbody>
      {data.beneficiaryAllPlans?.map((beneficiaryPlan: any, index: number) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={`plan-row-${index}`}>
          <PlanTableRow index={index} beneficiaryData={beneficiaryPlan} />
        </tr>
      ))}
    </tbody>
  );
};

export default PlanTableBody;
